module.exports = __webpack_public_path__ + "static/media/Image.248a3f7a.png";